/** Helpers for /ausschreibungen URLs. Mirrors `src/utils/leadRoutes.ts`. */

const instancePrefix = (): string => {
  const match = window.location.pathname.match(/^\/i\/[^/]+/);
  return match ? match[0] : '';
};

export function ausschreibungenListPath(): string {
  return `${instancePrefix()}/ausschreibungen`;
}

/**
 * Detail-URL mit der UUID wie bei Projekten und Kontakten. Die Display-ID (AUS-26-00007) wird
 * serverseitig weiterhin aufgelöst, alte Links bleiben gültig.
 */
export function ausschreibungDetailPath(a: {
  display_id?: string | null;
  id: string;
}): string {
  return `${instancePrefix()}/ausschreibungen/${encodeURIComponent(String(a.id))}`;
}
